export class PersonalDataPhones {
  id!: string;
  countryPrefixCode!: string;
  numberPhone!: string;
  countryIsoNumericCode!: string;
  type!: string;
  isPrincipal!: boolean;
  typeName!: string;
  emergencyPersonName?: string;
  emergencyPersonKinship?: string;
  isEmergency?: boolean;
}
